// 현장 액션(rpc) — 현장 상세의 착공·일정 변경·담당·준공·마감·하자보수 끝 날짜.
import { rpc } from "@/api/client";

export const startProject = (projectId: string, input: unknown) => rpc("project/actions/startProject", projectId, input);

export const rescheduleProject = (projectId: string, input: unknown) => rpc("project/actions/rescheduleProject", projectId, input);

export const setProjectAssignee = (projectId: string, input: unknown) => rpc("project/actions/setProjectAssignee", projectId, input);

export const completeProject = (projectId: string, input: unknown, force = false) => rpc("project/actions/completeProject", projectId, input, force);

export const closeProject = (projectId: string, input: unknown) => rpc("project/actions/closeProject", projectId, input);

export const setProjectWarrantyEnd = (projectId: string, input: unknown) => rpc("project/actions/setProjectWarrantyEnd", projectId, input);

export const createProjectFromContract = (contractId: string) => rpc("project/actions/createProjectFromContract", contractId);
